import React from "react";

export default function RolePermissionSummary({ summary }) {
  if (!summary) return null;

  return (
    <aside className="role-mgmt-summary" aria-label="Role summary">
      <div className="role-mgmt-summary__head">
        <h2 className="role-mgmt-summary__title">
          <i className="fas fa-wand-magic-sparkles" aria-hidden="true" />
          Summary
        </h2>
      </div>
      <div className="role-mgmt-summary__body">
        <p className="role-mgmt-summary__intro">{summary.intro}</p>
        {(summary.sections || []).map((section) => (
          <section key={section.id} className="role-mgmt-summary__section">
            <h3 className="role-mgmt-summary__module">
              <i
                className={`fas ${section.icon || "fa-cube"}`}
                style={{ color: section.color || "#7c3aed" }}
                aria-hidden="true"
              />
              <span>{section.label}</span>
              {section.total ? (
                <span className="role-mgmt-summary__count">
                  {section.grantedCount}/{section.total}
                </span>
              ) : null}
            </h3>
            {section.headline ? (
              <p
                className={`role-mgmt-summary__text${
                  section.mode === "full" ? " role-mgmt-summary__text--full" : ""
                }`}
              >
                {section.headline}
              </p>
            ) : null}
            {section.items?.length ? (
              <ul
                className={`role-mgmt-summary__list${
                  section.mode === "almost"
                    ? " role-mgmt-summary__list--cannot"
                    : ""
                }`}
              >
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
        {summary.note ? (
          <p className="role-mgmt-summary__note">{summary.note}</p>
        ) : null}
      </div>
    </aside>
  );
}
